import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\"><path stroke=\"currentcolor\" stroke-linejoin=\"round\" d=\"M8 1 1 4.841v8.297L8 17l7-3.862V4.84z\"></path><path stroke=\"currentcolor\" d=\"M15 4.841 8.115 9M1.181 4.841 8.115 9\"></path><path fill=\"currentcolor\" fill-rule=\"nonzero\" d=\"m5.69 2.48 6.396 3.78-1.742 1.065-6.305-3.942z\"></path><path stroke=\"currentcolor\" d=\"M8.1 17V9\"></path></g>", 1)
  ])))
}
export default { render: render }